import { ParameterType } from '@/study-search/enums';

import { Filter } from '../../Filter';
import { IIndexation } from '../../../../interfaces';
import { FilterKey } from '@studyportals/search-filters';

export class AreaFilter extends Filter implements IIndexation {
	public constructor() {
		super(FilterKey.AREA, ParameterType.AREA, [], true);
	}

	public canBeIndexed(): boolean {
		return this.values.length === 1;
	}
}
